module.exports = __webpack_public_path__ + "img/bottom_bg.099ca40.png";